/**
 * A lightweight and configurable Markdown renderer for React and Next.js.
 * Features include token-based rendering, GitHub callouts, math support, and footnotes.
 *
 * @remarks
 * This library is open source under the MIT license. Support and customization 
 * are available through [Code Media Labs](https://codemedialabs.in).
 */
import Markdown from "./Markdown";

export * from "./Markdown";
export type {
  CustomClasses,
  CustomComponents,
  CustomStyles,
  ParseOptions,
} from "./parser";

export default Markdown;
